import { Fragment } from "react";
import Skeleton from "react-loading-skeleton";
import SkeletonVideoCard from "./SkeletonVideoCard";

const SkeletonProfileSection = () => {
    // Get theme from localStorage (default to 'light' if not set)
    const theme = localStorage.getItem("theme") || "light";

    // Define colors for light and dark themes
    const skeletonColors = theme === "dark"
        ? { baseColor: "#23272F", highlightColor: "#3A3F4B" }
        : { baseColor: "#CECECE", highlightColor: "#E8E8E8" };

    return (
        <Fragment>
            <div className="relative">
                {/* Header section skeleton */}
                <div className="grid grid-cols-12 items-center px-2 pb-1 border-b border-gray-300 dark:border-gray-800">
                    <div className="col-span-3">
                        <Skeleton {...skeletonColors} height={23} width={23} circle={true} />
                    </div>
                    <div className="col-span-6" />
                    <div className="col-span-3 flex items-center justify-end gap-x-3">
                        <Skeleton {...skeletonColors} height={19} width={19} />
                    </div>
                </div>

                {/* Profile section skeleton */}
                <div className="grid grid-cols-12 px-2 mt-2 relative">
                    {/* Profile picture */}
                    <div className="col-span-6 h-full">
                        <div className="rounded-[50%] flex flex-col">
                            <div className="relative">
                                <Skeleton {...skeletonColors} height={77} width={77} circle={true} />
                            </div>
                        </div>
                    </div>

                    {/* Stats section */}
                    <div className="flex flex-col col-span-6">
                        <div className="flex flex-col justify-center items-center">
                            <div className="relative flex justify-center gap-8">
                                {/* Followers */}
                                <div className="w-auto h-10 text-[8px] font-bold justify-center items-center flex flex-col">
                                    <div className="flex items-center justify-center relative w-full">
                                        <Skeleton {...skeletonColors} height={13} width={13} />
                                    </div>
                                    <Skeleton {...skeletonColors} height={10} width={40} />
                                </div>
                                {/* Following */}
                                <div className="w-auto h-10 text-[8px] font-bold justify-center items-center flex flex-col">
                                    <div className="flex items-center justify-center relative w-full">
                                        <Skeleton {...skeletonColors} height={13} width={13} />
                                    </div>
                                    <Skeleton {...skeletonColors} height={10} width={45} />
                                </div>
                            </div>
                            {/* Posts */}
                            <div className="w-full h-10 items-center justify-center flex">
                                <div className="h-10 text-[8px] font-bold justify-center items-center flex flex-col w-10">
                                    <div className="flex items-center justify-center gap-x-1 relative w-full">
                                        <Skeleton {...skeletonColors} height={13} width={13} />
                                    </div>
                                    <Skeleton {...skeletonColors} height={10} width={45} />
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* User info section */}
                    <div className="col-span-12 mt-1">
                        {/* Name */}
                        <div className="flex mb-1">
                            <Skeleton {...skeletonColors} height={14} width={120} />
                        </div>
                        {/* Bio */}
                        <div className="mt-1">
                            <Skeleton {...skeletonColors} height={12} width="100%" />
                            <Skeleton {...skeletonColors} height={12} width="80%" />
                        </div>
                    </div>
                </div>

                {/* Action buttons skeleton */}
                <div className="px-2 pb-2 mt-0 flex items-center justify-center gap-2 border-b border-gray-300 dark:border-gray-800">
                    <div className="w-full">
                        <Skeleton {...skeletonColors} height={36} width="100%" />
                    </div>
                    <div className="w-full">
                        <Skeleton {...skeletonColors} height={36} width="100%" />
                    </div>
                </div>
                <SkeletonVideoCard />
            </div>
        </Fragment>
    );
};

export default SkeletonProfileSection;
